import {
	QUERY_PARAM_EPICS,
	QUERY_PARAM_VERSIONS,
	QUERY_PARAM_SELECTED_ISSUE,
} from '../../../model/routing/constants';

export const getCustomDataForMemoryAnalyticsFromUrl = () => {
	// use the URL parameters to determine whether any panels are open

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const queryParams = new URL(window.location.href).searchParams;
	return {
		isEpicPanelOpen: queryParams.has(QUERY_PARAM_EPICS),
		isVersionPanelOpen: queryParams.has(QUERY_PARAM_VERSIONS),
		isIssueViewOpen: queryParams.has(QUERY_PARAM_SELECTED_ISSUE),
	};
};
